import transport from '../transport';
export default transport;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio/es/services/auth/index.js
// module id = 2853
// module chunks = 39